/* eslint-disable array-callback-return */
import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { Card, Divider, List, ListItem, Badge } from "@mui/material";
import UndoOutlinedIcon from "@mui/icons-material/UndoOutlined";
import { useDispatch } from "react-redux";
import { enToFaDigit } from "../../utility/utils";
export default function NavBox({ customItems }) {
  let location = useLocation();
  const dispatch = useDispatch();
  // const layout = useSelector((state) => state.layout);
  // console.log("navBoxActiveItem", layout.navBoxActiveItem);

  const [activeItem, setActiveItem] = useState(
    sessionStorage.getItem("active")
  );
  const config = useSelector((state) => state.config);
  const navItems = customItems || config.NavBoxItems || [];
  // const items = activeItem ? navItems[activeItem].children : navItems;
  const items = activeItem !== null ? navItems[activeItem]?.children : navItems;
  const cart = useSelector((state) => state.cart);
  const cartList = cart.list;
  var count = 0;

  cartList?.map((item) => {
    count = count + item?.number;
  });

  return (
    <Card
      sx={{
        marginBottom: 1,
        mt: 2,
        boxShadow: "none",
        display: { xs: "none", md: "block" },
      }}
    >
      <List sx={{ display: "flex", flexDirection: "row", py: 0 }}>
        {activeItem !== null && (
          <span style={{ width: "100%", height: "60px", display: "flex" }}>
            <ListItem
              onClick={() => {
                setActiveItem(null);
                sessionStorage.clear("active");
              }}
              sx={{
                height: "100%",
                display: " flex",
                justifyContent: "center",
                transition: "all 0.3s",
                cursor: "pointer",
                color: "text.first",
                "&:hover": {
                  color: "text.first",
                  bgcolor: "transparent",
                },
              }}
            >
              <UndoOutlinedIcon fontSize="small" sx={{ mr: 1 }} />
              برگشت
            </ListItem>

            <Divider orientation="vertical" flexItem variant="middle" />
          </span>
        )}

        {items &&
          items.map((item, index) => {
            const hasChildren = item.children || false;

            return (
              <span
                key={item.path}
                style={{ width: "100%", height: "60px", display: "flex" }}
              >
                <ListItem
                  component={!hasChildren && Link}
                  to={item.path}
                  onClick={() => {
                    hasChildren && setActiveItem(index);
                    hasChildren && sessionStorage.setItem("active", index);

                    // hasChildren && dispatch(changeActiveNavBoxItem(index));
                  }}
                  sx={{
                    height: "100%",
                    display: " flex",
                    justifyContent: "center",
                    transition: "all 0.3s",
                    cursor: "pointer",
                    color: `${
                      location.pathname === item.path
                        ? "text.first"
                        : "text.primary"
                    }`,
                    "&:hover": {
                      color: "text.first",
                      bgcolor: "transparent",
                    },
                  }}
                >
                  {item?.path === "/cart" && cartList.length > 0 ? (
                    <Badge
                      badgeContent={enToFaDigit(count + "")}
                      color="secondary"
                      anchorOrigin={{
                        vertical: "top",
                        horizontal: "left",
                      }}
                      sx={{
                        "& .MuiBadge-badge": {
                          transform: "translate(30%, -30%) !important",
                        },
                      }}
                    >
                      <item.icon fontSize="small" sx={{ mr: 1 }} />
                      {item.name}
                    </Badge>
                  ) : (
                    <>
                      <item.icon fontSize="small" sx={{ mr: 1 }} />
                      {item.name}
                    </>
                  )}
                </ListItem>

                {index + 1 < items.length && (
                  <Divider orientation="vertical" flexItem variant="middle" />
                )}
              </span>
            );
          })}
      </List>
    </Card>
  );
}
